import { uploadCosImage, UploadOptions } from '@/material/form-upload/service';
import { base64ToFile } from '@/utils/file';

export const getVideoThumbnail = (
  src: string,
  time = 0,
  options?: UploadOptions,
): Promise<string> => new Promise((resolve) => {
  try {
    if (!src) {
      resolve('');
      return;
    }

    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.preload = 'auto';

    video.addEventListener('loadeddata', () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      video.currentTime = time;

      video.addEventListener('seeked', async () => {
        try {
          canvas.getContext('2d')?.drawImage(video, 0, 0);
          const imgData = canvas.toDataURL('image/webp', 0.8);
          const file = base64ToFile(imgData, 'thumbnail.webp');
          const res = await uploadCosImage(file, options);
          video.remove();
          console.log('Get video thumbnail successfully: ', res);
          resolve(res?.response?.url || '');
        } catch (err) {
          console.error('Get video thumbnail error: ', err);
          resolve('');
        }
      });
    });

    video.addEventListener('error', (err) => {
      video.remove();
      console.error('Get video thumbnail error: ', err);
      resolve('');
    });

    video.src = src;
    video.load();
  } catch (err) {
    console.error('Get video thumbnail error: ', err);
    resolve('');
  }
});
